$(document).ready(function () {
    navigationToggler();
    searchMobileToggle();
})

$('.header-navigation .search form input').keyup(function() {
    fetchResults();
});

function fetchResults() {
    var keyword = $('.header-navigation .search form input').val();
    var searchresults = $('.header-navigation .search form .search-results');

    if (keyword == "") {
        searchresults.removeClass('active');
        searchresults.html("");
    } else {
        $.ajax({
            url: awsm.ajax_url,
            type: 'post',
            data: {
                action: 'data_fetch',
                keyword: keyword
            },
            success: function(data) {
                searchresults.addClass('active');
                searchresults.html(data);
            }
        });
    }

    $(document).keydown(function(e) {
        if (e.keyCode == 27) {
            if (searchresults.hasClass('active')) {
                searchresults.removeClass('active');
                searchresults.html("");
                $('.header-navigation .search form input').val('').blur();
            }
        }
    });

    $(document).on("click", function(e) {
        if ($(e.target).is(".header-navigation .search form .search-results") === false) {
            searchresults.removeClass('active');
        }
    });
}

function searchMobileToggle() {
    var wrapper = $('header.header-navigation .wrapper .search');
    var toggle = wrapper.find('.icon.search');
    var form = wrapper.find('form');
    var close = wrapper.find('.close');

    toggle.on('click', function () {
       if (form.hasClass('active')) {
           form.removeClass('active');
       } else {
           form.addClass('active');
       }
    });

    close.on('click', function () {
        if (form.hasClass('active')) {
            form.removeClass('active');
        }
    })
}

function navigationToggler() {
    var toggle = $('header.header-navigation .wrapper .top-header .burger');
    var navigation = $('header.header-navigation .wrapper .bottom-header')

    toggle.on('click', function () {
        if ($(this).hasClass('clicked')) {
            $(this).removeClass('clicked');
            navigation.slideUp();
        } else {
            $(this).addClass('clicked');
            navigation.slideDown();
        }
    });
}